export const fundHouseConst = {
    CONTENT_UNAVAILABLE: "CONTENT_UNAVAILABLE",
    CONTENT_AVAILABLE: "CONTENT_AVAILABLE"
};
